// *******************************************************************************
// 1.0 - Open Filter dropdown
// *******************************************************************************

const filterdropdownEle = document.querySelectorAll('.filter-dropdown');
const filterdropdownPlaceholderEle = document.querySelectorAll('.filter-dropdown__label');

filterdropdownPlaceholderEle.forEach((el) => {
  el.addEventListener('click', () => {
    const filterdropdownParent = el.closest('.filter-dropdown');

    filterdropdownEle.forEach((elem) => {
      if (elem === filterdropdownParent) {
        // Is this the dropdown we clicked on? Just toggle the class
        elem.classList.toggle('is-open');
      } else {
        // Remove class from all other dropdowns on page
        elem.classList.remove('is-open');
      }
    });
  });
});

// *******************************************************************************
// 2.0 - Click on Filter dropdown option
// *******************************************************************************

const filterdropdownOptionEle = document.querySelectorAll('.filter-dropdown__list-option');

function changeDropdownValue(filterdropdownParent, optionParent, dropdownPlaceholderText) {
  // Change text
  const dropdownOptionText = optionParent.querySelector('.filter-dropdown__list-option').innerHTML;
  // eslint-disable-next-line no-param-reassign
  dropdownPlaceholderText.innerHTML = dropdownOptionText;

  // Close the dropdown
  filterdropdownParent.classList.remove('is-open');
  filterdropdownParent.classList.add('is-selected');
}

filterdropdownOptionEle.forEach((el) => {
  const filterdropdownParent = el.closest('.filter-dropdown');
  const optionParent = el.closest('.filter-dropdown__list-item');
  const optionInput = optionParent.querySelector('input');
  const dropdownPlaceholderText = filterdropdownParent.querySelector('.filter-dropdown__placeholder');

  optionInput.addEventListener('change', () => {
    changeDropdownValue(filterdropdownParent, optionParent, dropdownPlaceholderText);
  });

  el.addEventListener('click', () => {
    changeDropdownValue(filterdropdownParent, optionParent, dropdownPlaceholderText);
  });

  // Get text if any option selected by default
  if (optionInput.checked) {
    dropdownPlaceholderText.innerHTML = el.innerHTML;
    filterdropdownParent.classList.remove('is-open');
    filterdropdownParent.classList.add('is-selected');
  }
});

// *******************************************************************************
// 3.0 - Open a specific Filter dropdown based on has in url
// *******************************************************************************

document.addEventListener('click', (evt) => {
  const dropdownElemOpened = document.querySelector('.filter-dropdown.is-open');
  let targetElement = evt.target; // clicked element

  do {
    if (targetElement === dropdownElemOpened) {
      return;
    }
    targetElement = targetElement.parentNode;
  } while (targetElement);

  filterdropdownEle.forEach((el) => {
    const filterdropdownParent = el.closest('.filter-dropdown');
    filterdropdownParent.classList.remove('is-open');
  });
});
